import React from 'react';
import ModuleHeader from './ModuleHeader';

const toneByTitle = {
    'Bible Reader': 'sage',
    'Scripture Explorer': 'blue',
    'Prayer Guide Generator': 'plum',
    'Worship Videos': 'violet',
    'Worship Locator': 'copper'
};

const eyebrowByTitle = {
    'Bible Reader': 'Read the word',
    'Scripture Explorer': 'Find a passage',
    'Prayer Guide Generator': 'Personal guidance',
    'Worship Videos': 'Listen and worship',
    'Worship Locator': 'Find community'
};

const StandardHeader = ({ title, icon, actions }) => (
    <ModuleHeader
        title={title}
        eyebrow={eyebrowByTitle[title] || 'Prayer Guide'}
        icon={icon}
        tone={toneByTitle[title] || 'plum'}
        actions={actions}
    />
);

export default StandardHeader;
